import { render } from "./status_bookmark_folder_menu.vue?vue&type=template&id=467b64bd"
import script from "./status_bookmark_folder_menu.js?vue&type=script&lang=js"
export * from "./status_bookmark_folder_menu.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__